// src/travel-guides/travelGuidesApi.ts
import { apiClient } from "@maat/api-base";
var imageUpload = (url, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return apiClient.post(url, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
};
var BASE = "/main/api/travel-guides";
var travelGuidesApi = {
  list: () => apiClient.get(BASE),
  get: (guideId) => apiClient.get(`${BASE}/${guideId}`),
  create: (data) => apiClient.post(BASE, data),
  update: (guideId, data) => apiClient.patch(`${BASE}/${guideId}`, data),
  remove: (guideId) => apiClient.delete(`${BASE}/${guideId}`),
  submit: (guideId) => apiClient.post(`${BASE}/${guideId}/submit`),
  /** Upload the guide's cover (hero) image (multipart) → updated guide. */
  uploadCover: (guideId, file) => imageUpload(`${BASE}/${guideId}/cover`, file),
  // ── Sections ──
  createSection: (guideId, data) => apiClient.post(`${BASE}/${guideId}/sections`, data),
  updateSection: (guideId, sectionId, data) => apiClient.patch(`${BASE}/${guideId}/sections/${sectionId}`, data),
  deleteSection: (guideId, sectionId) => apiClient.delete(`${BASE}/${guideId}/sections/${sectionId}`),
  reorderSections: (guideId, ids) => apiClient.post(`${BASE}/${guideId}/sections/reorder`, { ids }),
  // ── Places ──
  createPlace: (guideId, sectionId, data) => apiClient.post(`${BASE}/${guideId}/sections/${sectionId}/places`, data),
  updatePlace: (guideId, sectionId, placeId, data) => apiClient.patch(`${BASE}/${guideId}/sections/${sectionId}/places/${placeId}`, data),
  deletePlace: (guideId, sectionId, placeId) => apiClient.delete(`${BASE}/${guideId}/sections/${sectionId}/places/${placeId}`),
  reorderPlaces: (guideId, sectionId, ids) => apiClient.post(`${BASE}/${guideId}/sections/${sectionId}/places/reorder`, { ids }),
  /** Upload a place's hero image (multipart) → permanent public URL. */
  uploadPlaceImage: (guideId, sectionId, placeId, file) => imageUpload(
    `${BASE}/${guideId}/sections/${sectionId}/places/${placeId}/image`,
    file
  )
};

export {
  travelGuidesApi
};
